import React from "react";
import { NavLink } from "react-router-dom";
import "../css/Sidebar.css";

export default function Sidebar({ open, isMobile, onClose }) {
  return (
    <aside className={`admin-sidebar ${isMobile && open ? "open" : ""}`}>
      <div className="side-brand" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        APT Admin
        {/* Close button — mobile only */}
        {isMobile && (
          <button
            onClick={onClose}
            style={{
              background: "none", border: "none",
              color: "inherit", fontSize: 20,
              cursor: "pointer", lineHeight: 1,
              padding: "0 4px",
            }}
            aria-label="Close menu"
          >
            ✕
          </button>
        )}
      </div>

      <nav className="side-nav">
        {[
          { to: "/",           label: "Stats",      end: true },
          { to: "/categories", label: "Catégories"            },
          { to: "/services",   label: "Services"              },
          { to: "/messages",   label: "Messages"              },
          { to: "/Users",      label: "Utilisateurs"            },
        ].map(({ to, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => isActive ? "side-link active" : "side-link"}
            onClick={isMobile ? onClose : undefined}
          >
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}